import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { Box } from "@mui/material"
import { MaximalLayoutWrapperPage } from "@ui-seeker/app"
import { copyToClipboard } from "@ui-seeker/utils"

import { ImageModal, DIPSkuGroupModal } from "@components"
import { useShareUrl, useToast } from "@hooks"
import { TourActions, TourProvider } from "@tour"
import PageWrapperActions from "./Actions"
import PageWrapperErrorPage from "./ErrorPage";


export default function PageWrapper({children, actions, tourPageKey, extraFilters={}, ...props}) {
    const { buildAbsoluteShareURL } = useShareUrl()
    const { showToast } = useToast()
    const isLoading = useSignal(false)

    const handleShareFilters = () => {
        isLoading.value = true
        buildAbsoluteShareURL(extraFilters)
            .then(({ res }) => {
                copyToClipboard(res)
                showToast.success('Short URL copied to clipboard!')
                isLoading.value = false
            })
            .catch(() => {
                showToast.error('Error generating short URL')
                isLoading.value = false
            })
    }

    return <>
        {tourPageKey && <TourProvider pageKey={tourPageKey} />}
        <MaximalLayoutWrapperPage
            showArrow
            noDataProps={{ imageProps: { width: "20%" } }}
            actions={
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1 }}>
                    {actions === undefined ? <PageWrapperActions {...props?.actionProps} /> : actions}
                    {tourPageKey && <TourActions pageKey={tourPageKey} />}
                </Box>
            }
            onClickTitle={handleShareFilters}
            tooltip="Generate short URL"
            isLoading={isLoading.value}
            linkButton={{ sx: { pl: 2 }}}
            {...props}
        >
            {props?.hasErrors ? (
                <PageWrapperErrorPage />
            ) : (
                children
            )}
        </MaximalLayoutWrapperPage>
        <ImageModal />
        <DIPSkuGroupModal />
    </>
}